import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/AxiosInstance.jsx';
import { handleResponse, handlePromise } from '../utils';

const useDevice = () => {
  return useQuery({
    queryKey: ['device'],
    queryFn: () => handlePromise(axiosInstance.get('/internal_api/tunnel/device')),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
const useSituationPro = () => {
  return useQuery({
    queryKey: ['situation-pro'],
    queryFn: () => handlePromise(axiosInstance.get('/internal_api/tunnel/situation-pro')),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
const useSchoolLevel = () => {
  return useQuery({
    queryKey: ['school-level'],
    queryFn: () => handlePromise(axiosInstance.get('/internal_api/tunnel/school-level')),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
const usePedagogical = () => {
  return useQuery({
    queryKey: ['pedagogical'],
    queryFn: () => handlePromise(axiosInstance.get('/internal_api/tunnel/pedagogicalPositioning')),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
const useQualiopi = (categoryId) => {
  return useQuery({
    queryKey: ['qualiopi', categoryId],
    queryFn: () => handlePromise(axiosInstance.get(`/internal_api/tunnel/qualiopi?categoryId=${categoryId}`)),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!categoryId,
  });
};
const useAgeQualification = () => {
  return useQuery({
    queryKey: ['age-qualification'],
    queryFn: () => handlePromise(axiosInstance.get(`/internal_api/tunnel/age-qualification`)),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    placeholderData: [],
  });
};

export { useDevice, useSituationPro, useSchoolLevel, usePedagogical, useQualiopi, useAgeQualification };
